module.exports = __webpack_public_path__ + "c3039e5793506c25be7e28b7ec9b3cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/options-black.png
// module id = 219
// module chunks = 0